module.exports = __webpack_public_path__ + "static/img/20.6f63151.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/5/eng/20.png
// module id = l4Ld
// module chunks = 0